import React from "react";
import PropTypes from "prop-types";
import { Button, ModalFooter } from "reactstrap";

const propTypes = {
  cancelFlowData: PropTypes.shape({
    retargeting_stats: PropTypes.shape({
      mtd_uniques: PropTypes.number.isRequired
    }).isRequired
  }).isRequired,
  onContinue: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired
};

const RetargetingStatsStep = ({ cancelFlowData, onContinue, onKeep }) => {
  const mtdUniques = cancelFlowData?.retargeting_stats?.mtd_uniques || 0;

  return (
    <div>
      <p className="text-center text-muted mb-3">
        Just so you know — your campaign has been retargeting website visitors.
      </p>

      <div className="text-center mb-3">
        <p className="mb-1">
          This month, your ads have reached{" "}
          <strong>{mtdUniques.toLocaleString()} unique website visitors</strong>.
        </p>
        <p className="text-muted mb-0">
          If you cancel, you&apos;ll lose the ability to retarget these visitors.
        </p>
      </div>

      <ModalFooter className="pt-2 px-0">
        <Button color="secondary" className="btn-sharp" onClick={onContinue}>
          Cancel Campaign
        </Button>
        <Button color="primary" className="btn-sharp" onClick={onKeep}>
          Continue Campaign
        </Button>
      </ModalFooter>
    </div>
  );
};

RetargetingStatsStep.propTypes = propTypes;

export default RetargetingStatsStep;
